import React, { useEffect, useState } from 'react';
import axios from 'axios';

const LocationFetcher = () => {
  const [location, setLocation] = useState({ lat: null, lon: null });
  const [responseMessage, setResponseMessage] = useState('');

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        position => {
          const { latitude, longitude } = position.coords;
          setLocation({ lat: latitude, lon: longitude });

          // Send location to backend
          axios.post('http://localhost:8090/api/saveLocation', {
            latitude,
            longitude
          }, {
            withCredentials: true
          })
          .then(response => {
            console.log('Location saved:', response.data);
            setResponseMessage(response.data); // Save backend response to show on screen
          })
          .catch(error => {
            console.error('Error saving location:', error);
            setResponseMessage('Error saving location to backend.');
          });
        },
        error => {
          console.error('Error getting location:', error);
          setResponseMessage('Failed to fetch location from browser.');
        }
      );
    } else {
      setResponseMessage("Geolocation is not supported by this browser.");
    }
  }, []);

  return (
    <div style={{ padding: '20px', fontFamily: 'Arial' }}>
      <h2>Your Current Location:</h2>
      <p><strong>Latitude:</strong> {location.lat ?? 'Loading...'}</p>
      <p><strong>Longitude:</strong> {location.lon ?? 'Loading...'}</p>

      <h3>Backend Response:</h3>
      <p>{responseMessage}</p>
    </div>
  );
};

export default LocationFetcher;
